$(document).on("change", "#form-brief .step.first input", function () {
	let $container = $(this).closest('.step.first');

	let $inputs = $container.find('input');

	let hasEmpty = $inputs.filter(function () {
		return !$(this).val();
	}).length > 0;

	if (!hasEmpty) {
		yaCounterReachGoal('brief-userinfo-filled');

		let data = {
			url: location.href,
		};
		$inputs.each(function (i, e) {
			let name = $(e).attr('name');
			data[name] = $(e).val();
		});

		$.post('/brief/userinfo-filled', data);
	}
});